import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import SupportCTA from './components/SupportCTA';
import Footer from './components/Footer';
import GuideSection from './components/GuideSection';

export default function App() {
  // Added explicit background colors, text colors, and fonts directly to the root div.
  // This ensures the dark theme renders perfectly even if the host platform overrides the <body> tag.
  return (
    <div 
      className="min-h-screen text-white font-space selection:bg-purple selection:text-white overflow-x-hidden relative"
      style={{ 
        backgroundColor: '#0D1B3E',
        backgroundImage: 'radial-gradient(circle at center, #0D1B3E 0%, #0A1628 100%)',
        backgroundAttachment: 'fixed'
      }}
    >
      <Navbar />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-24 relative z-10">
        <Hero />
        <GuideSection />
      </main>
      
      <div className="relative z-10">
        <SupportCTA />
        <Footer />
      </div>
    </div>
  );
}